import { LazyComponent } from "../../../utils/LazyComponent";

import type { LayoutRowProps } from "@op/puck-types";

const LayoutRow = (props: LayoutRowProps) => {
  return <LazyComponent<LayoutRowProps> name="LayoutRow" {...props} />;
};

export default LayoutRow;
